import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService) {}

  canActivate() {
    return this.checkIfActive();
  }

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkIfActive();
  }

  checkIfActive() {
    if ((this.authService.appToken || '').trim().length <= 0) {
      this.authService.login(true);
      return false;
    }
    return true;
  }
}
